<template>
  <router-link
    :to="{
      name: 'Campaign',
      params: { id: campaign.id },
    }"
    class="group pub-campaign-card border-zinc-300 border dark:border-transparent block w-full relative flex flex-col bg-base-300 rounded-md px-4 py-4 transition-all duration-50 cursor-pointer"
  >
      <div
        class="z-10 mb-2 flex justify-center items-center"
        style="max-height: 6rem; height: 6rem"
      >
        <figure
          class="flex justify-center items-center w-full"
          style="height: 6rem"
        >
          <img
            v-if="campaignImages?.length > 0"
            :src="
              campaignImages[0].conversions.filter(
                image => image.conversion === '300x200'
              )[0].storageUrl
            "
            class="object-cover w-full h-48 rounded-md block border border-base-100 dark:border-transparent group-hover/pub-campaign-card:scale-105 transition-all duration-300"
          />
          <!-- <img
            v-if="logoImage"
            :src="getImageUrl(logoImage, 'md')"
            :alt="`${campaign.name} logo`"
            class="h-full w-auto hover:-translate-y-2 duration-300"
          /> -->
        </figure>
      </div>

    <div class="z-10 flex flex-col justify-between h-full text-left">
      <h2 class="font-semibold pt-2 leading-5 line-clamp-2 h-12 text-sm flex items-center">
        <v-icon
          v-if="campaign.isFeatured"
          v-tooltip="'Featured'"
          class="mr-1 text-accent flex-shrink-0 -rotate-6"
          name="hi-solid-badge-check"
          scale="0.8"
        />
        <span class="line-clamp-2" v-tooltip="{ content: campaign.name, delay: { show: 750, hide: 0 } }">{{ campaign.name }}</span>
      </h2>

        <!-- <div class="flex">
                <div class="mt-0 w-100  flex flex-col justify-start gap-x-3 gap-y-1 mt-1 flex-wrap ">
                    <Tag
                    v-for="vertical in campaign.verticalTags"
                    :key="vertical.name"
                    class="mr-1 !bg-transparent border border-amber-300 !text-amber-400 !font-light"  
                    >{{ vertical.name }}
                    </Tag>
                </div>
            </div> -->

      <div class="flex flex-col mt-2.5 gap-[0.2rem] text-base-content/80">
          <div
            v-if="!computedPayouts"
            class="skeleton h-3 mb-1 w-full opacity-40"
          ></div>
          <div v-else class="text-sm flex items-center">
            <div>
              <v-icon
                name="md-attachmoney-round"
                size="6"
                class="mapMarker"
              ></v-icon>
            </div>
            <div class="text-xs font-normal">
              {{ payoutSummary ?? "Variable CPA" }}
            </div>
          </div>
          <div
            v-if="!computedPayouts"
            class="skeleton h-3 mb-1 w-full opacity-40"
          ></div>
          <div v-else class="flex text-xs font-normal items-center">
            <v-icon name="md-locationon-outlined" class="mapMarker"></v-icon>
            <ExpandableCountriesFromPayouts
              :payouts="computedPayouts ?? []"
            ></ExpandableCountriesFromPayouts>
          </div>
        </div>
        <CampaignStatus 
          :status="campaign.status"
          class="mt-3 -mb-1 z-10"
          :fullWidth="true"
        />
      <!-- <router-link
        :to="{
          name: 'Campaign',
          params: { id: campaign.id },
        }"
        class="bg-base-100/50 dark:bg-white/5 btn !h-8 !min-h-8 flex rounded-md block text-center uppercase text-xs py-2 mt-2.5 -mb-1 !cursor-pointer relative z-10 shadow-none border-none"
        :class="[getStatusButtonClasses(campaign.status)]"
      >
        <div v-if="!campaign.status" class="skeleton h-4 w-28 opacity-40"></div>
        <span v-else> {{ campaign.status }}</span>
      </router-link> -->
    </div>
  </router-link>
</template>

<script setup>
import { computed } from "vue"

import ExpandableCountriesFromPayouts from "@/components/common/ExpandableCountriesFromPayouts.vue"
import CampaignStatus from "@/components/common/CampaignStatus.vue"
import { getPayoutRangeString } from "@/utils/payoutRange"
import { useCampaignImages } from "@/composables/useCampaignImages.js"

const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
})

const { campaignImages } = useCampaignImages()

campaignImages.value = props.campaign.images


const computedPayouts = computed(() => {
  return props.campaign.status !== "subscribed" &&
    props.campaign.payoutsGlobal?.length > 0
    ? props.campaign.payoutsGlobal
    : props.campaign.payouts
})

const filteredPayouts = computed(() => {
  if (!computedPayouts.value) {
    return []
  }
  return computedPayouts.value.filter(payout => payout.value > 0)
})

const payoutSummary = computed(() => {
  return getPayoutRangeString(filteredPayouts.value)
})

</script>

<style scoped>
.mapMarker {
  @apply text-base-content/20 inline mr-1.5;
}
.cardSubheading {
  @apply text-xs font-bold text-blue-900 uppercase;
}
figure > img {
  @apply h-full w-full;
}
</style>
